import { FileSearchOutlined } from '@ant-design/icons';
import {
  ElencoFileDocumento,
  TipoComunicazioneFileAllegatoDTO,
  useGetBackProcedimentiIdFile,
} from '@framework/api-client';
import {
  FlexRow,
  ModalDialog,
  TableData,
  getNetworkErrorMessage,
} from '@framework/ui';
import { Button, Input, Space, TablePaginationConfig, message } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components';
import { useCommunicationsContext } from '../context/CommunicationsContext';
import { ICommonCommunicationProps } from '../logic/ICommonCommunicationProps';

const $Button = styled(Button)`
  /* border-left: 0; */
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  margin-left: -1px;
  z-index: 0;
  &:hover {
    z-index: 2;
  }
`;

export interface IAttachmentFromProcedureDialogProps {
  disabled?: boolean;
  attachmentGroup: TipoComunicazioneFileAllegatoDTO;
  attachExisting: ICommonCommunicationProps<any, any>['attachExisting'];
  communicationId: string | null | undefined;
}

/**
 * Dialog per allegare un file da un procedimento
 */
export function AttachmentFromProcedureDialog(
  props: IAttachmentFromProcedureDialogProps,
) {
  const { disabled, attachmentGroup, communicationId, attachExisting } = props;

  const [modalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selected, setSelected] = useState<ElencoFileDocumento | undefined>(
    undefined,
  );
  const [searchQuery, setSearchQuery] = useState<string>('');
  const { procedureId } = useCommunicationsContext();
  const { data, isFetching } = useGetBackProcedimentiIdFile(procedureId!);

  const pagination: TablePaginationConfig = {
    total: data?.length ?? 0,
    pageSize: 10,
  };
  return (
    <>
      <$Button
        icon={<FileSearchOutlined />}
        disabled={disabled}
        type="default"
        size="large"
        onClick={() => {
          setModalOpen(true);
        }}
      >
        Allega da procedimento
      </$Button>
      <ModalDialog
        destroyOnClose
        title={`Allega "${attachmentGroup.denominazione}" dal procedimento`}
        open={modalOpen}
        onCancel={() => {
          setSelected(undefined);
          setModalOpen(false);
        }}
        footer={
          <FlexRow
            left={<h4>{selected?.nomeFile ?? undefined}</h4>}
            right={
              <Space>
                <Button
                  onClick={() => {
                    setSelected(undefined);
                    setModalOpen(false);
                  }}
                >
                  Annulla
                </Button>
                <Button
                  disabled={selected == undefined}
                  loading={isLoading}
                  type="primary"
                  onClick={async () => {
                    try {
                      setIsLoading(true);
                      await attachExisting?.(
                        communicationId!,
                        attachmentGroup.id!,
                        selected!,
                      );
                      setModalOpen(false);
                      setIsLoading(false);
                      setSelected(undefined);
                    } catch (e) {
                      message.error(
                        getNetworkErrorMessage(
                          e,
                          `Si è verificato un errore durante l'aggiunta dell'allegato`,
                        ),
                      );
                    }
                  }}
                >
                  Allega
                </Button>
              </Space>
            }
          ></FlexRow>
        }
      >
        <>
          <FlexRow style={{ maxWidth: 600, marginBottom: 16 }} gutter={2}>
            <Input
              size="middle"
              value={searchQuery}
              onChange={e => {
                setSearchQuery(e.target.value);
              }}
              placeholder={'Cerca...'}
            />
          </FlexRow>
          {/* Tabella con tutti i file tornati dall'API con vicino un radio button */}
          <TableData
            darkTitleBar={false}
            showSorterTooltip={false}
            size="small"
            loading={isFetching}
            dataSource={data?.filter(d => {
              if (searchQuery === '') return true;

              return d.nomeFile
                ?.toLowerCase()
                ?.includes(searchQuery.toLowerCase());
            })}
            rowSelection={{
              type: 'radio',
              onChange: (_, selectedRows) => {
                setSelected(selectedRows[0]);
              },
            }}
            pagination={pagination}
            columns={[
              {
                title: 'Nome file',
                dataIndex: 'nomeFile',
              },
              {
                title: 'Tipo',
                dataIndex: 'tipo',
              },
            ]}
          />
        </>
      </ModalDialog>
    </>
  );
}
